var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('router-link',{staticClass:"link-toMain",attrs:{"to":"/"}},[_vm._v("На главную")])],1),(_vm.isAdmin)?_c('l-k-admin'):_c('l-k')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }